import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeSourceDate = async ({ docId, sourceDate }) => {
  let url = `/Docs/source_date/${docId}`;

  if (sourceDate) {
    url += `?sourceDate=${sourceDate}`;
  }

  return await request.put(
    url,
    null,
    'При изменении даты документа произошла ошибка',
    'Error'
  );
};

const useChangeSourceDate = () => {
  const mutation = useMutation(changeSourceDate, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingSourceDate: mutation.isLoading,
    changeSourceDate: mutation.mutateAsync,
  };
};

export default useChangeSourceDate;
